// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NCE7","colMin":"styles_colMin__ttomR"};